<template lang="pug">
.b-card(
    :class="[{ 'card--profile': profile, 'card--highlighted': highlight}, additionalClasses]",
    :is="url ? 'router-link' : 'article'",
    :to="url ? url : false",
    @click="$emit('click')"
)
    router-link.card__header-link.mb-4.py-0.d-inline-block.btn.btn-link.text-start(
        v-if="parsedBackLink",
        :to="parsedBackLink.url"
    ) {{ parsedBackLink.title }}
    ._heading.align-items-start.justify-content-between
        .w-100
            template(v-if="!profile")
                section.w-100.d-flex.mb-4(v-if="closed")
                    ._gradient-title Connected!
                    div.ms-auto Позиция закрыта

                header._title.mb-1.header-3(v-if="title") {{ title }}
                ._subtitle(v-if="subtitle") {{ subtitle }}
                ._subtitle.text--blue(v-if="subtitle2") {{ subtitle2 }}
            template(v-else)
                header._title.mb-1.justify-content-between.align-items-baseline.d-block.d-sm-flex.header-1(
                    v-if="title"
                ) {{ title }}
                    a.btn.button.header__button.d-block.mb-3.mb-md-0.ms-0.ms-md-3.mt-3.mt-md-0(
                        v-if="contactButton && !closed",
                        :href="contactButton"
                    ) Откликнуться
                    ._gradient-title(v-if="closed") Connected!
                .content(v-if="closed") Позиция закрыта
        img._image.ms-3(
            v-if="image && !profile",
            :src="image",
            :alt="title ? title : false"
        )
    template(v-if="!profile")
        ._content.mt-4.mb-3(v-if="text", v-html="text")
        ._tags.mt-2(v-if="tags && tags.length" v-for="(tagsSet, idx) in tags" :key="`tags-set-${idx}`")
            span.tag(v-for="(tag, idx) in tagsSet", :key="`card-tag-${idx}`" :style="{'backgroundColor':getTagColour(tag.id)}") {{ tag.name }}
        .label-3.fw-bold.mt-4(v-if="showMore") {{ showMore && typeof showMore === 'string' ? showMore : 'Подробнее' }}
    template(v-else)
        .d-block.d-md-flex.align-items-center.mt-4
            img._image.me-0.me-md-4.mb-4.mb-md-0(
                v-if="image",
                :src="image",
                :alt="title ? title : false"
            )
            ._subtitle
                .label-1.text--black {{ subtitle }}
                | {{ subtitle2 }}
        ._content.mt-5(v-if="text", v-html="text")
</template>

<script>
export default {
    name: "CardComponent",
    props: {
        url: { required: false, type: [String, Object], default: undefined },
        title: { required: false, type: String, default: undefined },
        subtitle: { required: false, type: String, default: undefined },
        subtitle2: { required: false, type: String, default: undefined },
        text: { required: false, type: String, default: undefined },
        image: { required: false, type: String, default: undefined },
        tags: { required: false, type: Array[Object], default: undefined },
        showMore: {
            required: false,
            type: [String, Boolean],
            default: undefined,
        },
        backLink: { required: false, type: [Boolean, Array], default: false },
        contactButton: {
            required: false,
            type: [String, Boolean],
            default: undefined,
        },
        profile: { required: false, type: Boolean, default: false },
        highlight: { required: false, type: Boolean, default: false },
        additionalClasses: { required: false, type: String, default: "" },
        closed: { required: false, type: Boolean, default: false },
    },
    computed: {
        parsedBackLink() {
            if (!this.backLink) return undefined;
            return typeof this.backLink === "boolean"
                ? { title: "К списку компаний", url: "/" }
                : { title: this.backLink[0], url: this.backLink[1] };
        },
    },
    methods: {
        getTagColour(tagId) {
            let colour = "";
            const filters = this.$store.state.filters;
            Object.keys(filters).forEach((filterType) => {
                if (
                    filters[filterType].items.map((i) => i.id).includes(tagId)
                ) {
                    colour = filters[filterType].colour;
                }
            });
            return colour;
        },
    },
};
</script>
